var KC2WorkModal = (function (base) {
  __extends(KC2WorkModal, base);

  function KC2WorkModal(apiClient) {
    var self = base.call(this, apiClient) || this;
    return self;
  };

  KC2WorkModal.prototype.activate = function (htmlContent) {
    const self = this;
    const $modal = ModalHelper.create().show().busy();
    self.$modal = $modal;

    var $form = $('form', $modal);

    $modal.content(htmlContent).busy(false);

    $modal
      .on('click', '[js=close],.close', () => {
        self.close({ cancel: true });
      })
      .on('keydown',
        e => {
          if (e.keyCode === 27) {
            self.close({ cancel: true });
            e.stopPropagation();
          }
        })
      .on('click', '[js=save]', function () {
        $modal.busy();
        self.close({ ok: true })
      });
  };

  return KC2WorkModal;
}(BaseModal));
